module.exports = __webpack_public_path__ + "088e9e3942970fdd9322ebe617175eed.MP3";